export const mockCampaignStoreQueries = {
  /**
   * Returns a collection of Stores using mock data.
   * Returns different set of stores depending on isWindowsStoreAd option, and noStores=true query parameter.
   * @param {Object} options Configuration options.
   * @param {Boolean} [options.isWindowsStoreAd=false] Specifies whether the request is for Windows Store Ads campaign
   * @returns {Promise<Object>} Stores collection data.
   */
  getActiveCampaignStores({
    isWindowsStoreAd = false,
  } = {}) {
    const createStoreObject =
      (active, global, storeId, networkList, oMatch, pMatch, rStoreId, rStoreName) => ({
        IsActive: active,
        IsGlobalStore: global,
        LinkedStoreId: storeId,
        NetworkTypes: networkList,
        OfferMatchCount: oMatch,
        ProductMatchCount: pMatch,
        RetailerStoreId: rStoreId,
        RetailerStoreName: rStoreName,
      });

    const globaStore = createStoreObject(true, true, 201, null, 0, 0, 201, 'Global Store Name 1');
    let stores;
    if (isWindowsStoreAd) {
      stores = [createStoreObject(true, false, 2949498, ['SPA', 'MicrosoftStore'], 0, 0, 108, 'Microsoft Store')];
    } else {
      stores = [
        createStoreObject(true, false, 2949491, ['SPA'], 0, 0, 101, 'MyStore101.com'),
        createStoreObject(true, false, 2949492, ['SPA'], 0, 0, 102, 'MyStore102.com'),
        createStoreObject(true, false, 2949493, ['SPB'], 0, 0, 103, 'MyStore103.com'),
        createStoreObject(true, false, 2949494, ['SPB'], 0, 0, 104, 'MyStore104.com'),
        createStoreObject(true, false, 2949495, ['SPA', 'SPB'], 0, 0, 105, 'MyStore105.com'),
        createStoreObject(true, false, 2949496, ['SPA', 'SPB'], 0, 0, 106, 'MyStore106.com'),
        createStoreObject(true, false, 2949497, ['SPA'], 0, 0, 107, 'MyStore107.com'),
      ];
    }

    const mockdata = [
      globaStore,
      ...stores,
    ];

    return Promise.resolve(mockdata);
  },
};
